import i18n from '@/locales'
import { getI18nLocale } from './languageUtils'
// 导入 Element Plus 的语言包 - 使用正确的导入路径
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import zhTw from 'element-plus/es/locale/lang/zh-tw'
import en from 'element-plus/es/locale/lang/en'
import pt from 'element-plus/es/locale/lang/pt'

export class LanguageManager {
  private static CACHE_KEY = 'system_settings'

  // 切换语言
  static switchLanguage(lang: 'zh_TW' | 'en_US' | 'pt_PT') {
    // 切换i18n语言
    const locale = getI18nLocale(lang)
    i18n.global.locale.value = locale as 'zh-TW' | 'zh-CN' | 'en' | 'pt' // 添加类型断言
    
    // 保存到缓存
    const settings = this.getSettingsFromCache() || {}
    settings.language = lang
    this.saveSettingsToCache(settings)

    // 更新页面标题
    this.updatePageTitle(lang)
  }

  // 保存系统设置到缓存
  static saveSettingsToCache(settings: Record<string, any>) {
    localStorage.setItem(this.CACHE_KEY, JSON.stringify(settings))
  }

  // 从缓存获取系统设置
  static getSettingsFromCache(): Record<string, any> | null {
    const settings = localStorage.getItem(this.CACHE_KEY)
    return settings ? JSON.parse(settings) : null
  }

  // 获取当前语言
  static getCurrentLanguage(): 'zh_TW' | 'en_US' | 'pt_PT' {
    const settings = this.getSettingsFromCache()
   //  console.log('settings', settings)
    return settings?.language || 'zh_TW'
  }
  
  // 获取 Element Plus 日历的语言配置
  static getElementPlusLocale() {
    const lang = this.getCurrentLanguage()
    // 将语言代码映射到 Element Plus 的语言包
    switch (lang) {
      case 'zh_TW':
        return zhTw
      case 'en_US':
        return en
      case 'pt_PT':
        return pt
      default:
        return zhTw // 默认使用简体中文
    }
  }

    // 更新页面标题
    static updatePageTitle(lang: 'zh_TW' | 'en_US' | 'pt_PT') {
      let title = '智校云校務管理系統';
      
      switch (lang) {
        case 'zh_TW':
          title = '智校云校務管理系統';
          break;
        case 'en_US':
          title = 'SmartSchool Cloud';
          break;
        case 'pt_PT':
          title = ' Escola Inteligente Cloud';
          break;
      }
      
      document.title = title;
    }
} 